/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Flex } from '@chakra-ui/react'
import {
  CompanyFavorite,
  Dnd,
  RankingCorporate,
  SearchCompany,
  SearchPost,
  TalkStory,
} from 'components/molecules'
import { DASHBOARD_FEATURES, TENANT_CODES } from 'constant/conmon'
import { FC } from 'react'
import { useDashboardContainer } from './hook'

/**
 * DashboardContainer organisms
 * @constructor
 */
export const DashboardContainer: FC = props => {
  const {
    observedDiv,
    childLayoutSize,
    parentLayoutSize,
    tenant,
    isFeatureVisible,
  } = useDashboardContainer(props)

  /**
   * Build dynamic components based on tenant and feature visibility
   * Only include components that are not in hidden_features list
   */
  const buildDynamicComponents = (): Record<string, JSX.Element> => {
    const components: Record<string, JSX.Element> = {}

    // Build horizontal layout components (RankingCorporate & TalkStory)
    const horizontalComponents: Record<string, JSX.Element> = {}
    let horizontalIndex = 0

    // Add RankingCorporate if visible (企業スコアランキング)
    if (isFeatureVisible(DASHBOARD_FEATURES.COMPANY_SCORE_RANKING)) {
      horizontalComponents[horizontalIndex.toString()] = <RankingCorporate />
      horizontalIndex++
    }

    // Add TalkStory if visible (トークネタ)
    if (isFeatureVisible(DASHBOARD_FEATURES.TALK_TOPICS)) {
      horizontalComponents[horizontalIndex.toString()] = <TalkStory />
      horizontalIndex++
    }

    // Only add the Dnd wrapper if there are visible components
    if (Object.keys(horizontalComponents).length > 0) {
      components['1'] = (
        <Dnd
          component={horizontalComponents}
          draggableHandle=".drag-horizontal"
          isBounded={true}
          lg={childLayoutSize}
          type="horizontal"
        />
      )
    }

    return components
  }

  // Show/Hide pagination size dropdown by tenant
  const isHidePaginationSizeDropdown = tenant === TENANT_CODES.FGL

  // Get dynamic components based on tenant and feature visibility
  let dynamicComponent: Record<string, JSX.Element> = {}

  switch (tenant) {
    case TENANT_CODES.MILIZE:
    case TENANT_CODES.FGL:
      dynamicComponent = buildDynamicComponents()
      break

    default:
      dynamicComponent = buildDynamicComponents()
      break
  }
  return (
    <Box boxSizing="border-box" w="100%">
      <Flex flexDirection="column" gap="16px" w="100%">
        <SearchCompany />
        <CompanyFavorite />
        <Dnd
          component={{
            '0': (
              <Box ref={observedDiv}>
                <SearchPost
                  isHidePaginationSizeDropdown={isHidePaginationSizeDropdown}
                  page="dashboard"
                />
              </Box>
            ),
            ...dynamicComponent,
          }}
          draggableHandle=".drag-vertical"
          isBounded={false}
          lg={parentLayoutSize}
          type="vertical"
          onDragStop={layout => {
            window.localStorage.setItem('element', JSON.stringify(layout))
          }}
        />
      </Flex>
    </Box>
  )
}
